import { authAxios } from "@/axios/axios";

export const getCustomer = async (id) => {
    const { data } = await authAxios.get(`customers/${id}/`);
    return data;
};

export const postCustomer = async (customer) => {
    const { data } = await authAxios.post(`customers/`, customer);
    return data;
};

export const patchCustomer = async (customer) => {
    const { data } = await authAxios.patch(`customers/${customer.id}/`, customer);
    return data;
};

export const deleteCustomer = async (id) => {
    const { data } = await authAxios.delete(`customers/${id}/`);
    return data;
};

export const deleteCustomers = async ({ ids = [] }) => {
    const { data } = await authAxios.delete(`customers/bulk/`, { data: ids });
    return data;
}

export const getCustomersById = async (ids = [], accept_adds = '') => {
    const { data } = await authAxios.post(`customers/bulk/`, ids, { params: { accept_adds, }, });
    return data;
}

export const getCustomers = async ({ limit, offset, ordering = [] }) => {
    const { data } = await authAxios.get(`customers/`, { params: { limit, offset, ordering: ordering.join(',') } });
    return data;
};

export const getCustomersIds = async (accept_adds = '', search, fields, ordering) => {
    const { data } = await authAxios.get(`customers/ids/`, {
        params: {
            accept_adds,
            search,
            fields,
            ordering,
        }
    });
    return data;
};

export const getCustomerReservations = async (id, { limit, offset, ordering = [] }) => {
    const { data } = await authAxios.get(`customers/${id}/reservations/`, { params: { limit, offset, ordering: ordering.join(',') } });
    return data;
};

export const getDuplicatedCustomers = async (field) => {
    const { data } = await authAxios.get(`customers/duplicates/`, { params: { field, }, });
    return data;
};

export const postBulkFuseCustomers = async (payload) => {
    const { data } = await authAxios.post(`customers/fuse/bulk/`, payload);
    return data;
};

export const postDownloadCustomersFile = async ({ onlyAcceptAds = true, customersIds, search, fields, ordering, }) => {
    const { data } = await authAxios.post(`customers/file/`,
        {
            customers_ids: customersIds,
        },
        {
            responseType: 'blob',
            params: {
                only_accept_ads: onlyAcceptAds,
                search,
                fields,
                ordering,
            },
        });
    return data;
}

/**
 * 
 * @param {string} value 
 * @param {string[]} fields 
 * @param {number} limit 
 * @param {number} offset 
 * @param {string[]} ordering 
 * @returns 
 */
export const getSearchCustomers = async (value, fields = [], limit, offset, ordering = []) => {
    const { data } = await authAxios.get(`customers/`, {
        params: {
            limit,
            offset,
            ordering,
            search: value,
            fields,
        },
    });
    return data;
}


// WEBPACK FOOTER //
// ./src/queries/customers/requests.js